import { useEffect, useState } from 'react';
import './Checkbox.css';

const Checkbox = ({checked, onChange, onClick, outlined, disabled }) => {

  const handleCheckbox = (e) => {
    if(!disabled) {
      onChange?.(!checked, e);
    }

  }


  return (
  <>
  <div className={`checkbox-component ${checked ? 'checked': ''} ${outlined? 'outlined': ''}`} onClick={handleCheckbox}>
    <svg width="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" height="100">
      <polyline points="20,50 40,70 80,30" stroke="none" strokeWidth="10" fill="none"></polyline>
    </svg>
    {/* <label className="checkbox-container">
      <input className="custom-checkbox"  type="checkbox"/>
        <span className="checkmark"></span>
    </label> */}
  </div>
  </>
  )
}

export default Checkbox